<script>
export default {
  name: 'PrivacyPolicy',
};
</script>
<template>
  <main class="col-lg-12 col-md-12 col-sm-12">
    <b-container fluid>
      <b-breadcrumb class="mt-1">
        <b-breadcrumb-item to="/privacyPolicy" active>Política de privacidad</b-breadcrumb-item>
      </b-breadcrumb>

      <div>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore
        magna aliqua. Pretium viverra suspendisse potenti nullam ac tortor vitae purus faucibus. Amet nisl purus in
        mollis. Hac habitasse platea dictumst vestibulum rhoncus. Mi proin sed libero enim. Tempor orci eu lobortis
        elementum nibh. Morbi enim nunc faucibus a pellentesque sit amet porttitor. Nisi lacus sed viverra tellus in.
        Facilisi morbi tempus iaculis urna id volutpat. Sem nulla pharetra diam sit amet nisl. Odio ut enim blandit
        volutpat maecenas volutpat blandit. Ut eu sem integer vitae justo eget magna fermentum. Id semper risus in
        hendrerit gravida rutrum quisque non. Bibendum at varius vel pharetra vel turpis nunc. Viverra maecenas accumsan
        lacus vel. Lectus quam id leo in vitae turpis. Eu non diam phasellus vestibulum lorem sed risus. Nulla facilisi
        nullam vehicula ipsum. Nisl nisi scelerisque eu ultrices vitae. Amet porttitor eget dolor morbi non arcu. Diam
        donec adipiscing tristique risus nec feugiat in. Feugiat nisl pretium fusce id. Aliquam vestibulum morbi blandit
        cursus risus at ultrices mi. Non pulvinar neque laoreet suspendisse interdum consectetur libero. Nisi
        scelerisque eu ultrices vitae auctor eu augue ut lectus. Etiam erat velit scelerisque in dictum non consectetur.
        Massa eget egestas purus viverra accumsan in nisl. Non blandit massa enim nec dui nunc. A erat nam at lectus
        urna. Massa ultricies mi quis hendrerit dolor magna eget est lorem. Dolor magna eget est lorem ipsum. Amet
        dictum sit amet justo donec enim diam vulputate ut. Augue lacus viverra vitae congue eu consequat ac felis. In
        egestas erat imperdiet sed euismod nisi porta lorem. Arcu non odio euismod lacinia at. Quam id leo in vitae
        turpis massa sed. Dui vivamus arcu felis bibendum ut tristique et egestas. Diam sollicitudin tempor id eu nisl
        nunc mi. Eu ultrices vitae auctor eu augue. Magna eget est lorem ipsum dolor. Rhoncus urna neque viverra justo
        nec ultrices. Sapien eget mi proin sed libero. Turpis cursus in hac habitasse platea dictumst quisque sagittis.
        Felis eget velit aliquet sagittis id consectetur. Lorem donec massa sapien faucibus et. Ultrices neque ornare
        aenean euismod elementum nisi. Adipiscing tristique risus nec feugiat in fermentum. In dictum non consectetur a
        erat nam at. Ut sem nulla pharetra diam sit amet nisl suscipit adipiscing. Faucibus turpis in eu mi bibendum
        neque egestas congue. Vivamus arcu felis bibendum ut tristique et egestas. Vivamus arcu felis bibendum ut
        tristique et. Ante in nibh mauris cursus mattis molestie a. Ornare quam viverra orci sagittis eu volutpat odio
        facilisis. In vitae turpis massa sed elementum tempus egestas sed. Scelerisque mauris pellentesque pulvinar
        pellentesque habitant. Commodo viverra maecenas accumsan lacus vel facilisis volutpat. Facilisis leo vel
        fringilla est ullamcorper. Nam aliquam sem et tortor consequat id porta. Risus ultricies tristique nulla aliquet
        enim. Faucibus et molestie ac feugiat sed lectus vestibulum mattis. Amet mattis vulputate enim nulla aliquet
        porttitor lacus. Turpis egestas pretium aenean pharetra magna ac placerat vestibulum. Facilisis gravida neque
        convallis a cras. Rhoncus dolor purus non enim. Tincidunt dui ut ornare lectus sit amet est placerat. Placerat
        duis ultricies lacus sed. Aliquet nibh praesent tristique magna sit amet purus gravida. Etiam sit amet nisl
        purus in. Commodo nulla facilisi nullam vehicula. Lacinia quis vel eros donec. Rutrum quisque non tellus orci ac
        auctor. In tellus integer feugiat scelerisque. Scelerisque felis imperdiet proin fermentum leo. Arcu vitae
        elementum curabitur vitae nunc sed velit dignissim sodales. Justo eget magna fermentum iaculis eu non diam. In
        cursus turpis massa tincidunt dui ut ornare lectus sit. Quam quisque id diam vel quam elementum pulvinar etiam
        non. Tellus in metus vulputate eu scelerisque.
      </div>
    </b-container>
  </main>
</template>

<style scoped>
.breadcrumb-item.active {
  color: #686868;
  font-size: 20px;
  text-decoration: none;
}

.breadcrumb {
  padding: 0.5rem 0;
  background-color: transparent;
}
</style>
